import './Calendar.overrides.css';
import { Icon } from '@components/icon/Icon';
import { useEffect, useState } from 'react';
import type { CalendarProps as ReactCalendarProps } from 'react-calendar';
import ReactCalendar from 'react-calendar';

type CalendarProps = {
  onDateChange: (value: Date) => void;
  value?: Date;
} & Omit<ReactCalendarProps, 'onChange' | 'value'> &
  React.RefAttributes<unknown>;

export const Calendar = (props: CalendarProps) => {
  const { onDateChange, value, ...restProps } = props;
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(value);

  useEffect(() => {
    setSelectedDate(value);
  }, [value]);

  const handleDateChange = (newValue: unknown) => {
    if (newValue instanceof Date) {
      setSelectedDate(newValue);
      onDateChange(newValue);
    }
  };

  return (
    <ReactCalendar
      calendarType="gregory"
      maxDetail="month"
      minDetail="month"
      nextAriaLabel="Next Month"
      nextLabel={<Icon name="arrowLeft" className="arrowRight" />}
      next2Label={null}
      onChange={handleDateChange}
      prevAriaLabel="Previous Month"
      prevLabel={<Icon name="arrowLeft" className="arrowLeft" />}
      prev2Label={null}
      showNeighboringMonth={false}
      view="month"
      value={selectedDate}
      {...restProps}
    />
  );
};
